import classnames from "classnames"
import styled from "styled-components"

const IconContainer = styled.i`
  ${(p) => `
  height: 1em;
  width: 1em;
  min-height: 1em;
  min-width: 1em;
  line-height: 1em;
  display: inline-block;
  /* flex wrapper for SVG causes SVG to be invisible in Safari */
  /*
    display: inline-flex;
    align-items: center;
    justify-content: center;
  */

  path {
    fill: ${p.fill || "currentColor"};
  }
`}
`

const Icon = ({ icon, fill, className, style, children, ...rest }) => {
  return (
    <IconContainer
      fill={fill}
      style={style}
      className={classnames(className, "Icon")}
      {...rest}
    >
      {children}
    </IconContainer>
  )
}

Icon.displayName = "Icon"

export default Icon
